<template>
<div>
 <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div  :class="{hasTagsView:needTagsView}" class="main-container">
      <div  :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
    </div>
  </div>
</div>

</template>

<script>
import { Navbar, Sidebar, AppMain,TagsView } from './components'
import commonPage from '@/views/commonPage/index'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import {localRead} from "@/utils/tools";
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    commonPage
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    // sidebar() {
    //   return this.$store.state.app.sidebar
    // },
    // device() {
    //   return this.$store.state.app.device
    // },
    // fixedHeader() {
    //   return this.$store.state.settings.fixedHeader
    // },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    toIndex(){
      //let router = localRead(this.$route.query.label + '_router');
      //if (router.indexOf("/analy/index") <= 0) return;
      if ("/Layout" == this.$route.path && this.$route.query.label == "TREX"){
        console.log("首页");
        this.$router.push({
          path: '/newmis36/analy/index',
          query: { label: 'TREX' }
        })
      }else if ("/Layout" == this.$route.path && this.$route.query.label == "MIS"){
        console.log("首页");
        this.$router.push({
          path: '/mis/analy/index',
          query: { label: 'MIS' }
        })
      }else if ("/Layout" == this.$route.path && this.$route.query.label == "INR"){
        console.log("首页");
        this.$router.push({
          path: '/cfinr/analy/index',
          query: { label: 'INR' }
        })
      }
    }
  },
  mounted() {
      this.toIndex();
  },
  watch:{
    $route: {
      deep:true,
      handler(oldval,newValue) {
        if (oldval.query.label != newValue.query.label){
          this.toIndex();
        }
      }
    }



  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
